import React, {FC} from 'react'
import {KTSVG} from '../../../helpers'
import CountUp from 'react-countup'

type Props = {
  backgroundColor: string
  color: string
  title: string
  stats: number | null
  svgIcon: {
    type: 'bootstrap' | 'duotune'
    path: string
    className: string
  } | null
}

const Card5: FC<Props> = ({backgroundColor, color, title, stats, svgIcon}) => {

  return (
      <div className="card h-100" style={{backgroundColor: stats !== null ? '#fff' : backgroundColor}}>
        <div
            className={`card-body py-3 py-sm-5 py-md-8 px-0  d-flex justify-content-center align-items-center flex-column`}>
          <div className="d-flex flex-column justify-content-center align-items-center my-7">
                    <span className="fw-semibold fs-3 text-uppercase fw-bolder mb-3 text-center"
                          style={{letterSpacing: 2, color: stats !== null ? color : '#fff'}}>
                        {title}
                    </span>
            {
              stats !== null ? (
                  <span className="fw-semibold fs-3x lh-1 ls-n2" style={{color: color}}>
                                <CountUp end={stats === -1 ? 0 : stats} duration={1.5} />
                            </span>
              ) : (
                  <></>
              )
            }
          </div>
          {
              svgIcon && <KTSVG path={svgIcon.path} className={`svg-icon svg-icon-2hx ${svgIcon.className}`} />
          }
        </div>
      </div>
  )
}

export {Card5}
